import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { TRANSLATION_KEYS } from 'partner360/widgets/ramManagerAssignment/translations'

import styles from './RamManagerAssignmentWelcome.module.scss'

interface IRamManagerAssignmentWelcomeProps {
  contacts: IFormJBPHPContactChangeRequest[]
}

export const RamManagerAssignmentWelcome = ({ contacts }: IRamManagerAssignmentWelcomeProps) => {
  const user = useSelector(selectUser)

  const userRoles = useMemo(() => {
    return Array.from(
      new Set(contacts.filter((el) => el.Email === user.email).flatMap((el) => el.Roles))
    ).join(', ')
  }, [contacts, user.email])

  return (
    <div className={styles.root}>
      <div>
        <div className={styles.title}>
          <Translation
            htmlAvailable
            text={TRANSLATION_KEYS.welcome.title}
            replaceParams={[{ key: '{name}', value: user.firstName }]}
          />
        </div>

        <RenderWhen condition={userRoles.length === 0}>
          <div className={styles.notRoles}>
            <Translation text={TRANSLATION_KEYS.welcome.notRoles} />
          </div>
        </RenderWhen>
        <Translation
          htmlAvailable
          text={
            userRoles.length
              ? TRANSLATION_KEYS.welcome.descriptionHasRoles
              : TRANSLATION_KEYS.welcome.description
          }
          replaceParams={[{ key: '{roles}', value: userRoles }]}
        />
      </div>
      <div className={styles.divider} />
    </div>
  )
}
